<template>
    <b-tab :title="$store.state.localization.data.mainPage.clients.tabs.main" active>
        <b-form-group>
          <b-form-checkbox v-model="user.isActive">
                {{
                  $store.state.localization.data.mainPage.users.userInfo.state
                }}
              </b-form-checkbox>
        </b-form-group>
        
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.userNameLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="user.userName"
            :state="isUserNameValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>
  
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.emailLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="user.email"
            :state="isEmailValid"
            required
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.clients.passwordLabel"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="user.password"
            :state="isPasswordValid"
            required
            style="font-size: 13px"
            :disabled="!isPassword"
          ></b-form-input>
          <b-form-checkbox v-model="isPassword">
              </b-form-checkbox>
        </b-form-group>
      </b-tab>
  </template>
  
  <script>
  
  export default {
    name: "MainTab",
    props: {
      user: Object
    },
    data() {
      return {
        isUserNameValid: null,
        isEmailValid: null,
        isPasswordValid: null,
        isPassword: false
      };
    },
    methods: {
      validate() {
        let isValid = true;

        if (!this.user.userName) {
          this.isUserNameValid = false;
          isValid = false;
        } else {
          this.isUserNameValid = null;
        }
  
        if (!this.user.email) {
          this.isEmailValid = false;
          isValid = false;
        } else {
          this.isEmailValid = null;
        }
  
        if (this.isPassword) {
            if (!this.user.password) {
              this.isPasswordValid = false;
              isValid = false;
            } else {
              this.isPasswordValid = null;
            }
        } else {
            this.isPasswordValid = null;
        }
  
        return isValid;
      },
      getMainData() {
        return this.user;
      }
    },
  };
  </script>
  